import classnames from "utilities/classnames";
import { ContactForm } from "../contactForm";
import { LegalLinks } from "../legalLinks";
import styles from "./styles.module.scss";

type ContactSectionProps = {
  className?: string;
};

/** Gets used on both contact page and mobile navbar menu */
export function ContactSection(props: ContactSectionProps) {
  const { className } = props;

  return (
    <section className={classnames(styles.root, className)}>
      <header>
        <h5>Contact Us</h5>
        <h2 className="txt-primary">Reach out</h2>
        <br />
        <p>
          We're here to help. Call us, email us or fill out the contact form. <br />
          We look forward to talking to you.
        </p>
      </header>
      <div className={styles.contact_content}>
        <div className={styles.contact_cards}>
          <div className={styles.contact_card}>
            <h4>Customer Service</h4>
            <br />
            <a href="tel:888-834-8434">(888) 834-8434</a>
            <br />
            <a href="mailto:support@flueid.com">support@flueid.com</a>
          </div>
          <div className={styles.contact_card}>
            <h4>Sales</h4>
            <br />
            <a href="tel:888-834-8434">(888) 834-8434</a>
            <br />
            <a href="mailto:sales@flueid.com">sales@flueid.com</a>
          </div>
          <div className={styles.contact_card}>
            <h4>Media</h4>
            <br />
            <a href="tel:737-703-3578">(737) 703-3578</a>
            <br />
            <a href="mailto:media@flueid.com">media@flueid.com</a>
          </div>
        </div>
        <ContactForm />
      </div>
      <footer className={styles.footer}>
        <LegalLinks />
      </footer>
    </section>
  );
}
